<template>
  <Modal :model-value="isOpen" title="Edit Email" @update:model-value="$emit('close')">
    <div>
      <label class="mb-1 block text-xs font-semibold text-slate-700">Email</label>
      <input
        v-model="localDraft.email"
        type="email"
        class="w-full rounded-xl px-4 py-3 text-sm bg-white/70 dark:bg-slate-900/40
               border border-slate-200/60 dark:border-slate-700/60
               text-slate-800 dark:text-slate-100
               placeholder:text-slate-400 dark:placeholder:text-slate-500
               shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2
               focus:ring-offset-white dark:focus:ring-offset-slate-900
               focus:ring-[#ff8e48]/60"
      />
      <p v-if="!localDraft.email" class="mt-1 text-xs text-red-500">{{ emailError }}</p>
    </div>

    <template #footer>
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        @click="$emit('close')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-primary to-secondary px-4 py-2 text-sm font-semibold text-white
               shadow-sm hover:brightness-110 transition disabled:cursor-not-allowed disabled:opacity-60"
        :disabled="loading"
        @click="handleSave"
      >
        Save
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { reactive, watch } from 'vue'
import Modal from '@/components/layout/Modal.vue'

interface Draft {
  firstName: string
  lastName: string
  username: string
  dateOfBirth: string
  gender: string
  address: string
  city: string
  state: string
  zipcode: string
  phone: string
  email: string
}

const props = defineProps<{
  isOpen: boolean
  draft: Draft
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'save', draft: Draft): void
}>()

// Create a local reactive copy of the draft
const localDraft = reactive<Draft>({ ...props.draft })

// Watch for changes in props.draft and update localDraft
watch(() => props.draft, (newDraft) => {
  Object.assign(localDraft, newDraft)
}, { deep: true })

const handleSave = () => {
  emit('save', { ...localDraft })
}

const emailError = 'Email is required.'
</script>
